<section class="hm-registry">
  <div class="hm-registry-inner">
    <p class="hm-eyebrow">
      {{ member ? 'Your register' : 'The Registry' }}
    </p>
    <h2 class="hm-registry-title">
      {{
        member
          ? 'Your registrations, on the record.'
          : 'Every registration has a page here. Including yours.'
      }}
    </h2>
    <p class="hm-registry-lead">
      {{
        member
          ? 'Every registration you add or track has its permanent page: availability, verified sales, valuation and history, kept in one place for good.'
          : 'The Registry is the permanent record of the market: one page for every registration, whether it is for sale or not. Its availability, verified sales, valuation and history, kept in one place for good.'
      }}
    </p>
    <div class="hm-registry-grid">
      <div
        class="hm-registry-point"
        *ngFor="let point of member ? memberPoints : publicPoints"
      >
        <h3>{{ point.title }}</h3>
        <p>{{ point.copy }}</p>
      </div>
    </div>
    <!-- Direct registration entry (feedback 23 Jul): type the plate here,
         no detour via search. Public: straight to its permanent page.
         Member: adds to the register (ownership unverified until the
         account flow verifies it). -->
    <form
      class="hm-registry-entry"
      (ngSubmit)="member ? addToRegister() : findPage()"
    >
      <label class="hm-registry-input">
        <span class="visually-hidden">{{
          member ? 'Registration to add to your register' : 'Find a registration'
        }}</span>
        <input
          type="text"
          name="registration"
          [placeholder]="member ? 'Your registration, e.g. PLA 73X' : 'Enter a registration, e.g. PLA 73X'"
          [(ngModel)]="regInput"
          autocomplete="off"
          autocapitalize="characters"
        />
      </label>
      <button class="hm-btn hm-btn--green" type="submit">
        {{ member ? 'Add to your register' : 'Find its page' }}
      </button>
    </form>
    <p class="hm-registry-feedback" *ngIf="addState === 'added'">
      {{ addedRegistration }} added · ownership unverified ·
      <a routerLink="/account/registrations">complete its record</a>
    </p>
    <p class="hm-registry-feedback" *ngIf="addState === 'failed'">
      That could not be added right now.
      <a routerLink="/account/registrations">Try from your account</a>
    </p>
  </div>
</section>
